import './_nav-menu';
import './_team';
import './_timeline';
import './_scroll-to';
import './_slideshow';
import './_search';
import './_feedback-form';
import './_archive';
import './_menu-scroll';
import './facts-image';
import './_block-press-releases.js';

import { initMap } from "./_map.js";
window.initMap = initMap;

jQuery(function () {
    function replaceCO2InHTML(element) {
        let html = element.html();
        // Replace CO2 with CO<sub>2</sub>, but avoid:
        // - already subscripted ones
        // - text inside img tags
        html = html.replace(/CO2(?![^<]*<\/sub>)(?![^<]*>)/g, 'CO<sub>2</sub>');
        element.html(html);
    }
    
    // Add subscript to these elements (and their children)
    $("h1, h2, p, a").each(function () {
        replaceCO2InHTML($(this));
    });
    
});